import * as _ from 'lodash';
import { IRecipient } from '@nkr/models/index';
import { Button, Col, Glyphicon, Panel, PanelGroup, Row, FormGroup, FormControl, Alert, HelpBlock } from 'react-bootstrap';
import { FormEventHandler, useState } from 'react';

interface IProps {
    labLastReviewedDate: string,
    labLastReviewedDateError: string,
    recipient: IRecipient,
    labReviewHistory: string[],
    pendingChanges: boolean,
    handleInputChange: FormEventHandler<FormControl>,
    onToggle: (hla: string, antigen: number) => void,
    onToggleBoolean: (avoid: number) => void,
    handleSaveAvoids: () => void
}

const Hla = {
    A: 'A',
    B: 'B',
    Dr: 'DR',
    Bw: 'Bw',
    Cw: 'Cw',
    Dq: 'Dq',
    Dqa: 'DQa',
    Dp: 'DP'
};

interface IHlaValueItem {
    hla: string,
    label: string,
    antigenArray: number[]
}

const hlaList: IHlaValueItem[] = [
    { hla: Hla.A, label: 'A', antigenArray: [1, 2, 3, 11, 23, 24, 25, 26, 29, 30, 31, 32, 33, 34, 36, 43, 66, 68, 69, 74, 80] },
    { hla: Hla.B, label: 'B', antigenArray: [7, 8, 13, 18, 27, 35, 37, 38, 39, 41, 42, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 67, 71, 72, 73, 75, 76, 77, 78, 81, 82, 2708, 4005] },
    { hla: Hla.Dr, label: 'DR', antigenArray: [1, 4, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 103] },
    { hla: Hla.Bw, label: 'Bw', antigenArray: [4, 6] },
    { hla: Hla.Cw, label: 'Cw', antigenArray: [1, 2, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14, 15, 16, 17, 18, 999] },
    { hla: Hla.Dq, label: 'DQb', antigenArray: [2, 4, 5, 6, 7, 8, 9] },
    { hla: Hla.Dqa, label: 'DQa', antigenArray: [1, 2, 3, 4, 5, 6] },
    { hla: Hla.Dp, label: 'DPb', antigenArray: [1, 2, 3, 5, 6, 9, 10, 11, 13, 14, 15, 17, 18, 19, 20, 23, 28, 401, 402, 999] }
];

const RecipientAntibodies = (props: IProps) => {
    const [expanded, setExpanded] = useState<string[]>([]);

    const handlePanelSelect = (eventKey: any) => {
        let newExpanded = [...expanded];

        if (newExpanded.indexOf(eventKey) >= 0) {
            newExpanded = newExpanded.filter(k => k != eventKey);
        } else {
            newExpanded.push(eventKey);
        }

        setExpanded(newExpanded);
    };

    const handleExpandAll = () => {
        let newExpanded = hlaList.map(x => x.hla);
        newExpanded.push('dr5');
        setExpanded(newExpanded);
    };

    const handleCollapseAll = () => {
        setExpanded([]);
    };

    let dr51To53Count =
        (props.recipient.hlaAvoids.avoidDr51 ? 1 : 0)
        + (props.recipient.hlaAvoids.avoidDr52 ? 1 : 0)
        + (props.recipient.hlaAvoids.avoidDr53 ? 1 : 0);

    return (
        <Panel bsStyle={props.pendingChanges ? 'warning' : 'default'}>
            <Panel.Heading>
                <Panel.Title>Antibodies</Panel.Title>
            </Panel.Heading>

            <Panel.Body>
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 3 }}>
                    <Button bsSize='xs' onClick={handleExpandAll}><Glyphicon glyph='plus' /> Expand All</Button>
                    <Button bsSize='xs' onClick={handleCollapseAll}><Glyphicon glyph='minus' /> Collapse All</Button>
                </div>

                <PanelGroup style={{ marginBottom: 15 }}>
                    <>
                        {hlaList.map(item => {
                            let f = props.recipient.hlaAvoids[item.hla.toLowerCase() + 'Avoids'];
                            let x = f != null ? f as number[] : [];
                            let isExpanded = expanded.indexOf(item.hla) >= 0;

                            return (
                                <Panel eventKey={item.hla} expanded={isExpanded}>
                                    <Panel.Heading onClick={() => handlePanelSelect(item.hla)}>
                                        <div style={{ display: 'flex', cursor: 'default' }}>
                                            <Glyphicon style={{ fontSize: 10, paddingTop: 3 }} glyph={isExpanded ? 'triangle-bottom' : 'triangle-right'} />
                                            <Panel.Title style={{ fontSize: 14 }}>
                                                {item.label} Antibodies ({x.length})
                                            </Panel.Title>
                                        </div>
                                    </Panel.Heading>
                                    <Panel.Collapse>
                                        <Panel.Body>
                                            <Row>
                                                {item.antigenArray.map(antigen =>
                                                    <Col xs={12} md={3} lg={3}>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <input id={item.hla + antigen} type='checkbox' style={{ margin: '0px 5px 0px 0px' }} checked={x.indexOf(antigen) >= 0} onClick={() => props.onToggle(item.hla, antigen)} /><label style={{ fontWeight: 400, marginBottom: 0 }} htmlFor={item.hla + antigen}>{item.hla}{antigen}</label>
                                                        </div>
                                                    </Col>
                                                )}
                                            </Row>
                                        </Panel.Body>
                                    </Panel.Collapse>
                                </Panel>
                            );
                        })}

                        <Panel eventKey={'dr5'} expanded={expanded.indexOf('dr5') >= 0}>
                            <Panel.Heading onClick={() => handlePanelSelect('dr5')}>
                                <div style={{ display: 'flex', cursor: 'default' }}>
                                    <Glyphicon style={{ fontSize: 10, paddingTop: 3 }} glyph={expanded.indexOf('dr5') >= 0 ? 'triangle-bottom' : 'triangle-right'} />
                                    <Panel.Title style={{ fontSize: 14 }}>DR51 - DR53 Antibodies ({dr51To53Count})</Panel.Title>
                                </div>
                            </Panel.Heading>
                            <Panel.Collapse>
                                <Panel.Body>
                                    <Row>
                                        {_.range(51, 54).map(antigen => {
                                            let checked = props.recipient.hlaAvoids['avoidDr' + antigen];

                                            return (
                                                <Col xs={12} md={3} lg={3}>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <input id={'avoidDr' + antigen} type='checkbox' style={{ margin: '0px 5px 0px 0px' }} checked={checked} onClick={() => props.onToggleBoolean(antigen)} /> <label style={{ fontWeight: 400, marginBottom: 0 }} htmlFor={'avoidDr' + antigen}>DR{antigen}</label>
                                                    </div>
                                                </Col>
                                            );
                                        })}
                                    </Row>
                                </Panel.Body>
                            </Panel.Collapse>
                        </Panel>
                    </>
                </PanelGroup>

                <Row>
                    <Col xs={4}>
                        <FormGroup validationState={props.labLastReviewedDateError ? 'error' : null}>
                            <label className='control-label'>Last Luminex Antibody Testing Reviewed Date</label>
                            <FormControl
                                className='input-group'
                                type='date'
                                id='date'
                                name='labLastReviewedDate'
                                value={props.labLastReviewedDate}
                                max={`${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`}
                                onChange={props.handleInputChange}
                            />
                            {props.labLastReviewedDateError && <HelpBlock>{props.labLastReviewedDateError}</HelpBlock>}
                        </FormGroup>
                    </Col>

                    <Col xs={8}>
                        {props.recipient.labLastReviewedDate != '' && (
                            <div style={{ fontSize: 12 }}>
                                {props.labReviewHistory.length > 0 && (
                                    <div>Review History: {props.labReviewHistory.join(', ')}</div>
                                )}
                            </div>
                        )}
                    </Col>
                </Row>

                <Row>
                    <Col xs={2}>
                        <Button bsStyle='primary' block onClick={props.handleSaveAvoids}>SAVE</Button>
                    </Col>

                    <Col xs={6}>
                        {props.pendingChanges && (
                            <Alert bsStyle='warning'>
                                <strong>PENDING CHANGES:</strong> Please click 'SAVE' to confirm changes.
                                <br />
                                <strong>NOTE:</strong> Please ensure avoids and review date are up to date prior to saving.
                            </Alert>
                        )}
                    </Col>
                </Row>
            </Panel.Body>
        </Panel>
    );
}

export default RecipientAntibodies;